"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewHolland = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const Tags_1 = require("../Tags");
const TileType_1 = require("../../TileType");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const Board_1 = require("../../boards/Board");
const Units_1 = require("../../Units");
class NewHolland extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.NEW_HOLLAND,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.BUILDING],
            cost: 20,
            productionBox: Units_1.Units.of({ megacredits: 3 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.cities(4).any()),
            metadata: {
                cardNumber: 'X??',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(3)).nbsp().tile(TileType_1.TileType.NEW_HOLLAND);
                    ;
                }),
                description: 'Requires 4 city tiles ON MARS. Increase your M€ production 3 steps. Place this tile on top of an existing ocean tile, following normal city placement restrictions. This tile counts as a city as well as an ocean.',
            },
        });
    }
    canPlay(player) {
        if (!super.canPlay(player))
            return false;
        const citiesCount = player.game.getCitiesInPlayOnMars();
        if (citiesCount < 4)
            return false;
        let eligibleSpaces = player.game.board.getOceansTiles(false);
        if (player.cardIsInEffect(CardName_1.CardName.GORDON))
            return eligibleSpaces.length > 0;
        eligibleSpaces = eligibleSpaces.filter((space) => player.game.board.getAdjacentSpaces(space).some((adjacentSpace) => Board_1.Board.isCitySpace(adjacentSpace)) === false);
        return eligibleSpaces.length > 0;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 3);
        let eligibleSpaces = player.game.board.getOceansTiles(false);
        if (player.cardIsInEffect(CardName_1.CardName.GORDON) === false) {
            eligibleSpaces = eligibleSpaces.filter((space) => player.game.board.getAdjacentSpaces(space).some((adjacentSpace) => Board_1.Board.isCitySpace(adjacentSpace)) === false);
        }
        return new SelectSpace_1.SelectSpace('Select space for New Holland', eligibleSpaces, TileType_1.TileType.CITY, (space) => {
            const tile = {
                tileType: TileType_1.TileType.NEW_HOLLAND,
                card: this.name,
                covers: space.tile,
            };
            player.game.addTile(player, space.spaceType, space, tile);
            return undefined;
        });
    }
}
exports.NewHolland = NewHolland;
//# sourceMappingURL=NewHolland.js.map